"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/counterSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type CounterSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "K" */
    h40Text: ReactNode;
    /** Detected variants: "Happy Clients" | "Counseling Completed" | "Awards Won" */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-3 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "counter-item-fifteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "count" */
    h40ClassName?: string;
    /** Detected variants: "count-digit" */
    span0ClassName?: string;
    /** Detected variants: "isVisible && (\n                    <CountUp className=\"number\" end={5000} duration={2} />\n                  )" | "isVisible && (\n                    <CountUp className=\"number\" end={1200} duration={2} />\n                  )" | "isVisible && (\n                    <CountUp className=\"number\" end={150} duration={2} />\n                  )" */
    div0h40span0Expr0: ReactNode;
};
export type HomeFifteenCounterSectionGeneratedProps = {
    divDiv0H40H4Props?: Partial<ComponentProps<"h4">> | ((item: CounterSection366sItem) => Partial<ComponentProps<"h4">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div3Div0DivDataWowDuration?: string;
    /** Default: "24/7" */
    sectionDiv0Div0Div3Div0H40H4Text?: ReactNode;
    /** Default: "Customer Support" */
    sectionDiv0Div0Div3Div0P0PText?: ReactNode;
    counterSection366s: CounterSection366sItem[];
    counterSection366sItemWrapper?: (item: CounterSection366sItem, content: ReactNode) => ReactNode;
    counterSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    counterSection366sH4Visible?: boolean;
    counterSection366sH4Renderer?: (item: CounterSection366sItem, defaultNode: ReactNode) => ReactNode;
    counterSection366sH4Props?: Partial<ComponentProps<"h4">> | ((item: CounterSection366sItem) => Partial<ComponentProps<"h4">>);
};

const HomeFifteenCounterSectionGenerated: FC<HomeFifteenCounterSectionGeneratedProps> = ({
    sectionDiv0Div0Div3Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div3Div0H40H4Text = "24/7",
    sectionDiv0Div0Div3Div0P0PText = "Customer Support",
    divDiv0H40H4Props,
    sectionDiv0Div0ClassName,
    counterSection366s,
    counterSection366sItemWrapper,
    counterSection366sRenderer,
    counterSection366sH4Visible,
    counterSection366sH4Renderer,
    counterSection366sH4Props,
}) => {
    return (
        <section className="section counter-section-fifteen pt-0">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row row-gap-4"}>
                    {renderCollectionNode(
                        counterSection366s,
                        (item: CounterSection366sItem) => (
                            <div className={item.className ?? "col-lg-3 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "counter-item-fifteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    {renderItemNode(counterSection366sH4Visible, counterSection366sH4Renderer, item, (
                                        <h4 className={item.h40ClassName ?? "count"} {...(typeof counterSection366sH4Props === "function" ? counterSection366sH4Props(item) : (counterSection366sH4Props ?? {}))} {...(typeof divDiv0H40H4Props === "function" ? divDiv0H40H4Props(item) : (divDiv0H40H4Props ?? {}))}>
                                            <span className={item.span0ClassName ?? "count-digit"}></span>
                                            {item.h40Text}
                                        </h4>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            </div>
                        ),
                        counterSection366sItemWrapper,
                        counterSection366sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFifteenCounterSectionGenerated;
